import { useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';

export default function useSidebarCollapsed() {
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));
  const opened = useSelector((state) => state.customization.opened);
  return matchUpMd && !opened;
}